module.exports = __webpack_public_path__ + "img/opendoor3.9fc1794a.png";